module.exports = __webpack_public_path__ + "static/media/openbrixlogo.87cc9289.svg";